














































import { Component, Prop, Emit } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { Col, ColInfo } from '.'

@Component({
  components: {}
})
export default class DataTableRow extends ComponentVue {
  @Prop({
    type: Array
  })
  cols!: Col[]

  @Prop({
    type: Array
  })
  colsInfo!: ColInfo[]

  @Prop({
    type: Array
  })
  colsOrderList!: number[]

  @Prop({
    type: Number
  })
  height!: number

  @Prop({
    type: Number
  })
  index!: number

  @Prop({
    type: [Object, String]
  })
  item!: object | string

  @Prop({
    type: Number
  })
  itemsCount!: number

  get rowNo(): number {
    return this.index + 1
  }

  get descRowNo(): number {
    return this.itemsCount - this.index
  }

  @Emit('click:row')
  onClickRow(): number {
    return this.index
  }
}
